<template>
	<div class="container-fluid rasa-auth">
		<div class="row h-100">
			<div class="col-12 col-md-5 content">
				<div class="col-12 mb-3 logo">
					<img src="../../../assets/img/aniresan.png" />
					<strong class="pt-2 d-block">به آنی رسان خوش آمدید</strong>
				</div>
				<auth-login v-on:stateChanged="stateChange" v-if="state == 'login'" />
				<auth-register v-on:stateChanged="stateChange" v-if="state == 'register'" />
				<auth-forgot-password v-on:stateChanged="stateChange" v-if="state == 'forgot-password'" />
			</div>
			<div class="col-12 col-md-7 d-none d-md-block p-0">
				<div class="image"></div>
			</div>
		</div>
	</div>
</template>

<script>

	import AuthLogin from "./auth-login.vue";
	import AuthRegister from "./auth-register.vue";
	import AuthForgotPassword from "./auth-forgot-password.vue";

	export default {

		components: {
			"auth-login": AuthLogin,
			"auth-register": AuthRegister,
			"auth-forgot-password": AuthForgotPassword
		},

		data()
		{
			return {
				state: "login"
			}
		},

		methods: {
			stateChange(state)
			{
				this.state = state;
			}
		}
	}
</script>

<style scoped>
	.rasa-auth,
	.rasa-auth .content {
		width: 100%;
		height: 100%;
	}

		.rasa-auth .content {
			max-width: 450px;
			margin: 0 auto;
			padding-top: 50px;
		}

			.rasa-auth .content .logo {
				width: 100%;
				text-align: center;
			}

			.rasa-auth .content .forget {
				color: #bb0013;
				cursor: pointer;
			}

				.rasa-auth .content p:hover {
					color: #bb0013;
				}

		.rasa-auth .image {
			background-image: url("../../../assets/img/postBox.jpg");
			background-size: cover;
			background-repeat: no-repeat;
			height: 100%;
			position: relative;
			border-radius: 0 0 200px 0;
		}

			.rasa-auth .image::after {
				content: "";
				position: absolute;
				background: #000;
				opacity: 0.3;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				border-radius: 0 0 200px 0;
			}
</style>
